import pluralize from 'pluralize';
import React from 'react';

import { subscriber_profile_path } from '@routes';
import { article_path } from '@routes';
import { articleDate } from '@utils/dates';

import styles from './styles.module.scss';

type ArticleAuthor = {
  username: string;
  name: string;
};

export type ArticleAuthors = ArticleAuthor[];

export default function AuthorsLine({
  authors,
  date,
  commentCount,
  slug,
}: {
  authors: ArticleAuthors;
  date: string;
  commentCount: number;
  slug: string;
}) {
  return (
    <div className={styles.authorsLine}>
      By{' '}
      {authors.map((author, index) => (
        <span key={index}>
          <a href={subscriber_profile_path(author.username)}>{author.name}</a>
          {index < authors.length - 1 && <span> and </span>}
        </span>
      ))}
      <span> &middot; {articleDate(date)}</span>
      {!!commentCount && (
        <span>
          {' '}
          &middot;{' '}
          <a
            href={article_path(slug, { anchor: 'comments-anchor' })}
            className="track-link"
            data-type="link"
            data-name="article comments"
            data-location="feed"
          >
            {commentCount} {pluralize('comment', commentCount)}
          </a>
        </span>
      )}
    </div>
  );
}
